import { DATE_TIME, UUID } from '@belimo-retrofit-portal/logic';
import { Json } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { ASSET } from 'src/modules/common/codecs/Asset';
import { USER_ROLE } from 'src/modules/common/codecs/UserRole';
import { OrganizationUser } from 'src/modules/users/types/OrganizationUser';

export const ORGANIZATION_USER: C.Codec<unknown, Json, OrganizationUser> = C.struct({
  id: UUID,
  email: C.string,

  role: USER_ROLE,

  firstName: C.string,
  lastName: C.string,

  jobTitle: C.nullable(C.string),
  avatar: C.nullable(ASSET),

  createdAt: DATE_TIME,
  latestActivity: C.nullable(DATE_TIME),
});
